import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { differenceWith, isEqual } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "Select2",
  props: {
    data: {
      type: [Object, Array],
      default: null
    },
    options: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: null,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    formatData: {
      type: null,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    initOnMounted: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    preventTyping: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectClassName() {
      const classes = [];
      if (this.value === "" || this.value === null) classes.push("select-field-empty");else classes.push("form-control-filled");
      return classes.join(" ");
    }
  },
  watch: {
    "$i18n.locale"() {
      this.reset();
    },
    value(value) {
      this.setValue(value);
    },
    data(data, oldData) {
      if (!$(this.$el).data("select2")) return;
      const diff = differenceWith(data, oldData, isEqual);
      if (!diff.length && (data == null ? void 0 : data.length) === (oldData == null ? void 0 : oldData.length)) return;
      this.reset();
    },
    formatData() {
      if (!$(this.$el).data("select2")) this.reset();
    }
  },
  mounted() {
    if (this.initOnMounted) this.initSelect2();
  },
  activated() {
    this.initSelect2();
  },
  destroyed() {
    const select = $(this.$el);
    select.off();
    if (select.data("select2")) {
      select.select2("destroy");
    }
  },
  methods: {
    initSelect2(customOptions) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const optionsToUse = customOptions || this.options;
          if ($(this.$el).data("select2")) return;
          const data = this.formatData ? this.formatData(this.data) : this.data;
          const options = data ? _objectSpread({
            data
          }, optionsToUse) : optionsToUse;
          $(this.$el).select2(options).on("select2:select", event => this.$emit("change", event.params.data, "select")).on("select2:unselect", event => this.$emit("change", event.params.data, "unselect")).on("select2:close", event => this.$emit("close", event)).on("select2:open", event => {
            this.$emit("open", event);
            if (this.preventTyping) {
              this.$nextTick(() => {
                const searchInput = document.querySelector(".select2-search__field");
                if (searchInput) {
                  searchInput.setAttribute("readonly", "readonly");
                }
              });
            }
          });
          this.setValue(this.value);
          const searchInput = _findInstanceProperty($).call($, ".select2-search__field:not([id]):first");
          const selectId = $(searchInput).offsetParent().prev().attr("id");
          $(searchInput).attr("id", `${selectId}-search`);
        });
      });
    },
    setValue(value) {
      this.$nextTick(() => {
        $(this.$el).val(value).trigger("change").trigger("input");
      });
    },
    setSelectedOption(option) {
      return option.value === this.value;
    },
    open() {
      this.$nextTick(() => {
        $(this.$el).select2("open");
      });
    },
    close() {
      this.$nextTick(() => {
        $(this.$el).select2("close");
      });
    },
    reset(data = this.data) {
      this.$nextTick(() => {
        data = this.formatData ? this.formatData(data) : data;
        $(this.$el).select2().empty();
        $(this.$el).select2(_objectSpread({
          data
        }, this.options));
        this.setValue(this.value);
      });
    }
  }
});